import { SVGProps } from 'react'

export const Email = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M13.334 2.667H2.667c-.733 0-1.327.6-1.327 1.333l-.007 8c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333V4c0-.733-.6-1.333-1.333-1.333zm0 2.666L8 8.667 2.667 5.333V4L8 7.333 13.334 4v1.333z"
    ></path>
  </svg>
)
